import React from "react";
import imgRobot from "../../assets/img/mex/planes/mia.svg";
const MessageMia = ({ textMessage = "", content, showContent = false }) => {
  return (
    <div className="d-flex align-items-center mt-2">
      <div className="align-items-center">
        <img src={imgRobot} className="imgRbt" alt="Mia" />
      </div>
      <div className="message-mia">
        <div>{textMessage}</div>
        {showContent && <div> {content}</div>}
      </div>
    </div>
  );
};

export default MessageMia;
